/**
 * 权益补贴 -- 结算方
 */
export default function subsidySettleType(val) {
    let str = '';
    switch (val) {
    case 'STORE':
        str = '4S店';
        break;
    case 'VEHICLE_OWNER':
        str = '所有人';
        break;
    case 'BENEFICIARY':
        str = '受益人';
        break;
    case 'EMP':
        str = '内部员工';
        break;
    case 'KINSFOLK':
        str = '所有人亲属';
        break;
    default:
        break;
    }
    return str;
}
